import Suspense from "components/shared/Suspense";
import { lazy, useState } from "react";
import { useDispatch } from "react-redux";
import { searchActions } from "store/search/searchSlice";
import { PageSerializersBooksLayout } from "types/serializers";
import FlagButton from "../FlagButton";

const DuplicateModal = lazy(() => import("../parts/DuplicateModal"));

export interface Props {
  book: PageSerializersBooksLayout;
}

export default function ReportBookButtonContent({ book }: Props) {
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const dispatch = useDispatch();

  const toggleDuplicate = () => {
    setShowDuplicateModal(!showDuplicateModal);
  };

  const onClose = () => {
    setShowDuplicateModal(false);
    dispatch(searchActions.reset());
  };

  return (
    <>
      <FlagButton
        onDuplicate={toggleDuplicate}
        menuProps={{
          id: book.id,
          type: "Book",
          title: book.title,
          editLink: `/books/${book.id}/edit`,
          adminLink: `/admin/books/${book.slug}`,
        }}
      />

      {showDuplicateModal && (
        <Suspense>
          <DuplicateModal onClose={onClose} object={book} type="Books" />
        </Suspense>
      )}
    </>
  );
}
